"use client"

import React from "react"

import { useProductAsLowAs } from "@modules/products/hooks/use-product-as-low-as"

interface InstallmentPriceProps {
  finalPrice: string
  customerExternalId?: string
}

/**
 * Installment price component specifically styled for the cart dropdown
 * Shows product price in installments with full-width styling
 */
const InstallmentPrice = ({ finalPrice, customerExternalId }: InstallmentPriceProps) => {
  // Use the TanStack Query hook to fetch and manage installment data
  const { data: asLowAs, isLoading: loading } = useProductAsLowAs(finalPrice, customerExternalId)

  // Destructure the data from the query result
  const { installments, amount } = asLowAs || {}

  return (
    <div
      className={`flex h-10 w-full items-center justify-center rounded-lg transition-colors duration-300 ${
        loading ? "animate-pulse bg-gray-50" : "bg-nelo-sky-200"
      }`}
      aria-busy={loading}
    >
      {installments && amount && (
        <div className="flex items-center justify-center">
          <span className="mr-1 font-manrope font-bold text-ui-fg-base">{amount}</span>
          <span className="mr-1 font-manrope text-ui-fg-base">por</span>
          <span className="mr-1 font-manrope font-bold text-ui-fg-base">{installments} quincenas</span>
          <span className="font-manrope text-ui-fg-base">sin intereses</span>
        </div>
      )}
    </div>
  )
}

export default InstallmentPrice
